import type { TourPolicyItem, TourRefundPolicyInput } from "api/types/tours.types";
import type { TourPolicyKind } from "utils/type/tour-policy";

// BE `buccl_main/constants.py` 와 같은 값 (works-228 · issue-539)
export const TOUR_POLICY_MIN_ITEMS = 1;
export const TOUR_POLICY_MAX_ITEMS = 10;
export const TOUR_POLICY_PERIOD_MAX_LENGTH = 100;
export const TOUR_POLICY_RATE_MAX_LENGTH = 20;
export const TOUR_REFUND_DAYS_BEFORE_MAX = 3650;
/** 회원 직접 취소는 이 환불율(%) 구간에서만 허용된다 */
export const TOUR_MEMBER_CANCEL_RATE_PERCENT = 100;

export const TOUR_POLICY_COLOR_PATTERN = /^#[0-9A-Fa-f]{6}$/;
/** 색상 미지정 행에 color input 이 보여줄 값 (저장 값 아님) */
export const TOUR_POLICY_FALLBACK_COLOR = "#9E9E9E";

export const DEFAULT_DEPOSIT_REFUND_POLICY: TourRefundPolicyInput[] = [
  {
    period: "결제 후 출발 45일 전까지",
    rate: "100%",
    color: "#4CAF50",
    days_before: 45,
    rate_percent: 100,
  },
  {
    period: "출발 44일 전부터",
    rate: "환불 불가",
    color: "#F44336",
    days_before: 0,
    rate_percent: 0,
  },
];

export const DEFAULT_PENALTY_POLICY: TourPolicyItem[] = [
  { period: "출발 30일 전까지", rate: "100%", color: "#4CAF50" },
  { period: "출발 15~29일 전", rate: "70%", color: "#8BC34A" },
  { period: "출발 7~14일 전", rate: "50%", color: "#FF9800" },
  { period: "출발 3~6일 전", rate: "30%", color: "#FF5722" },
  { period: "출발 2일 전부터", rate: "환불 불가", color: "#F44336" },
];

export const TOUR_POLICY_LABELS: Record<TourPolicyKind, string> = {
  refund: "예약금 환불 규정",
  penalty: "위약금 규정 (강사 프로그램 비용)",
};

export const TOUR_POLICY_DESCRIPTIONS: Record<TourPolicyKind, string> = {
  refund: "예약금 환불 기준입니다. '기준일'은 출발 N일 전 23:59:59 까지 적용되며, 환불율 100% 구간에서만 회원이 직접 취소할 수 있습니다. 기준일·환불율을 바꾸면 기간·환불 문구의 숫자가 함께 바뀝니다 (숫자가 맞지 않는 직접 쓴 문구는 그대로 둡니다).",
  penalty: "강사 프로그램 비용(잔금)의 취소 위약금 기준입니다. 화면 표시용이며 결제 계산에는 쓰이지 않습니다.",
};

/** 규정 종류 → 요청·400 응답의 필드 키 */
export const TOUR_POLICY_FIELD_KEYS: Record<TourPolicyKind, "refund_policy" | "penalty_policy"> = {
  refund: "refund_policy",
  penalty: "penalty_policy",
};
